import { apiRequest } from "@/lib/api";
import type {
  DiscountCoupon,
  DiscountCouponListResponse,
  DiscountCouponPayload,
} from "@/types/coupon";

const COUPON_ENDPOINT = "/coupons/";

export type PublicCouponValidationPayload = {
  code: string;
  subtotal: string | number;
};

export type PublicValidatedCoupon = {
  id: number;
  code: string;
  description: string;
  discount_type: "percentage" | "fixed";
  discount_type_label: string;
  discount_value: string;
};

export type PublicCouponValidationResponse = {
  valid: true;
  coupon: PublicValidatedCoupon;
  subtotal: string;
  discount_amount: string;
  total: string;
};

export function getCoupons() {
  return apiRequest<DiscountCouponListResponse>(
    COUPON_ENDPOINT,
    {
      authenticated: true,
    },
  );
}

export function createCoupon(
  payload: DiscountCouponPayload,
) {
  return apiRequest<DiscountCoupon>(
    COUPON_ENDPOINT,
    {
      method: "POST",
      authenticated: true,
      body: JSON.stringify(payload),
    },
  );
}

export function updateCoupon(
  couponId: number,
  payload: Partial<DiscountCouponPayload>,
) {
  return apiRequest<DiscountCoupon>(
    `${COUPON_ENDPOINT}${couponId}/`,
    {
      method: "PATCH",
      authenticated: true,
      body: JSON.stringify(payload),
    },
  );
}

export function deleteCoupon(
  couponId: number,
) {
  return apiRequest<void>(
    `${COUPON_ENDPOINT}${couponId}/`,
    {
      method: "DELETE",
      authenticated: true,
    },
  );
}

export function validatePublicCoupon(
  slug: string,
  payload: PublicCouponValidationPayload,
) {
  return apiRequest<PublicCouponValidationResponse>(
    `/coupons/public/${slug}/validate/`,
    {
      method: "POST",
      body: JSON.stringify({
        code: payload.code.trim(),
        subtotal: String(payload.subtotal),
      }),
    },
  );
}
